import type { AppState } from '@capacitor/app'
import mitt from 'mitt'

type Events = {
  appScroll: HTMLElement
  windowResize: undefined
  docContentClicked: undefined
  headerScrollUpdate: undefined
  showActionMenu: undefined
  overlayMenuOpened: undefined
  overlayMenuClosed: undefined
  closeOverlayMenu: undefined
  logoutOfflineFailure: undefined
  openSortPopup: undefined
  toggleNightMode: undefined
  docContentSelectionStarted: undefined
  showBookControlBar: undefined
  closeInAppBrowser16218: undefined
  stripeFinishedLoading: undefined
  hesitationPopupOpen: undefined
  hesitationPopupClose: undefined
  appVisibilityChange: AppState
  checklistShowPopup: undefined
}

export const emitter = mitt<Events>()
